import { Button } from '@progress/kendo-react-buttons';
import { Checkbox, Input } from '@progress/kendo-react-inputs';
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import CustomModal from 'commons/modal/CustomModal';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import 'scss/_projectDetail.scss';
import CreateMessagesModal from './modals/CreateMessagesModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetDivisionsQuery, useGetMediasQuery, useRemoveAnnonceMutation, useUpdateAnnonceMutation } from '../../../redux/api/cache';

export default function MessageDetail(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [modifyModalVisible, setModifyModalVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { data: mediasDropDown } = useGetMediasQuery();
  const { data: divisionDropDown } = useGetDivisionsQuery();
  const [updateAnnonce] = useUpdateAnnonceMutation();
  const [removeAnnonce] = useRemoveAnnonceMutation();

  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    wrapperStyle,
    ...others
  } = props;

  return (
    <div>
      <div
        style={{
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
          margin: '50px 15px 0 15px',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            border: '1px #f3f5f5 solid',
            borderBottom: '0px white solid',
            borderRadius: '1px',
            boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
            padding: '15px 30px 15px 30px',
            marginTop: '15px',
          }}
        >
          <h1
            style={{
              textTransform: 'uppercase',
              color: 'dimgrey',
              fontWeight: 'bold',
              fontSize: '22px',
            }}
            className="me-auto"
          >
            {props.data.rowData.ann_descr}
          </h1>
        </div>
      </div>
      <CollapsableCard
        type="none"
        canCollapse={false}
        style={{ backgroundColor: 'white' }}
      >
        <Body>
          <div className="inline" style={{ marginBottom: '15px' }}>
            <Button
              className="me-auto whiteButton"
              style={{ margin: '2px' }}
              onClick={() => {
                setModifyModalVisible(true);
              }}
            >
              Modifier
            </Button>
            <Button
              icon={'trash'}
              className="whiteButton"
              style={{ margin: '2px', borderRadius: '50%' }}
              onClick={() => {
                setDeleteModalVisible(true);
              }}
            ></Button>
          </div>
          <div className="row">
            <div className="col-md-1">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>No :</span>
            </div>
            <div className="col-md-2">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Média :
              </span>
            </div>
            <div className="col-md-1">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Durée :
              </span>
            </div>
            <div className="col-md-3">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Raison retrait :
              </span>
            </div>
            <div className="col-md-3">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Divisions :
              </span>
            </div>
            <div className="col-md-1">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Intemporelle :
              </span>
            </div>
            <div className="col-md-1">
              <span style={{ fontWeight: 'bold', color: '#a5a5a5' }}>
                Retiré :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-1">
              <Input
                valid={valid}
                type={type}
                id={id}
                disabled={true}
                value={props.data.rowData.ann_num}
                className="customInput"
                {...others}
              />
            </div>
            <div className="col-md-2">
              <Input
                valid={valid}
                type={type}
                id={id}
                disabled={true}
                value={
                  mediasDropDown?.data?.find(
                    (item) => item.media_cd === props.data.rowData.media_cd
                  )?.media_cd
                }
                className="customInput"
                {...others}
              />
            </div>
            <div className="col-md-1">
              <Input
                valid={valid}
                type={type}
                id={id}
                disabled={true}
                value={props.data.rowData.ann_duree}
                className="customInput"
                {...others}
              />
            </div>
            <div className="col-md-3">
              <Input
                valid={valid}
                type={type}
                id={id}
                disabled={true}
                value={props.data.rowData.ann_raison_retrait}
                className="customInput"
                {...others}
              />
            </div>
            <div className="col-md-3">
              <Input
                valid={valid}
                type={type}
                id={id}
                disabled={true}
                value={props.data.rowData.div_num_lst
                  .split(',')
                  .map(
                    (id) =>
                      divisionDropDown?.data?.find(
                        (div) => div.div_num === parseFloat(id)
                      )?.div_nom
                  )}
                className="customInput"
                {...others}
              />
            </div>
            <div className="col-md-1">
              <Checkbox
                disabled={true}
                style={{
                  width: '38px',
                  height: '38px',
                  borderColor: 'lightgrey',
                }}
                value={props.data.rowData.ann_intemp}
              />
            </div>
            <div className="col-md-1">
              <Checkbox
                disabled={true}
                style={{
                  width: '38px',
                  height: '38px',
                  borderColor: 'lightgrey',
                }}
                value={props.data.rowData.ann_retire}
              />
            </div>
            <span
              style={{
                fontSize: '17px',
                color: 'dimgrey',
                fontWeight: 'bold',
                marginLeft: '15px',
                marginTop: '15px',
              }}
            >
              Notes:
              <span style={{ fontWeight: 'normal' }}>
                {' '}
                {props.data.rowData.ann_note !== ''
                  ? props.data.rowData.ann_note
                  : 'N/A'}
              </span>
            </span>
          </div>
        </Body>
        {modifyModalVisible && (
          <CreateMessagesModal
            create={async (values) => {
              await updateAnnonce(values);
            }}
            selectedRow={props.data.rowData}
            toggleDialog={() => {
              setModifyModalVisible(false);
            }}
          ></CreateMessagesModal>
        )}
        {deleteModalVisible && (
          <CustomModal
            width={'15%'}
            title="Confirmation"
            onClose={() => {
              setDeleteModalVisible(!deleteModalVisible);
            }}
            body={<p>Supprimer {props.data.rowData.ann_descr} ?</p>}
            buttons={[
              {
                onClick: () => {
                  setDeleteModalVisible(!deleteModalVisible);
                },
                text: 'Non',
              },
              {
                onClick: async () => {
                  let result = await removeAnnonce({ ann_seq: props.data.rowData.ann_seq }).unwrap();
                  if (result.success) {
                    let url = location.pathname.split('/Numero=');
                    navigate(url[0]);
                    setDeleteModalVisible(!deleteModalVisible);
                  }
                },
                text: 'Oui',
              },
            ]}
          ></CustomModal>
        )}
      </CollapsableCard>
    </div>
  );
}

MessageDetail.propTypes = {
  data: PropTypes.shape({
    rowData: PropTypes.shape({
      ann_descr: PropTypes.any,
      ann_duree: PropTypes.any,
      ann_intemp: PropTypes.any,
      ann_note: PropTypes.any,
      ann_num: PropTypes.any,
      ann_raison_retrait: PropTypes.any,
      ann_retire: PropTypes.any,
      ann_seq: PropTypes.any,
      div_num_lst: PropTypes.any,
      media_cd: PropTypes.any,
    }),
  }),
  //update: PropTypes.func,
};
